import { render, staticRenderFns } from "./HeaderLanguages.vue?vue&type=template&id=bebd5086&scoped=true&"
import script from "./HeaderLanguages.js?vue&type=script&lang=js&"
export * from "./HeaderLanguages.js?vue&type=script&lang=js&"
import style0 from "./HeaderLanguages.scss?vue&type=style&index=0&id=bebd5086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebd5086",
  null
  
)

export default component.exports